import { PortalModule } from '@angular/cdk/portal';
import { NgModule } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';

import { CoreModule } from '@core';
import { environment } from '@env/environment';
import { LayoutModule } from '@layout/layout.module';
import { CustomHammerConfig } from '@shared/hammer-config/custom-hammer-config';

import { AppRoutingModule } from './app-routing.module';
import { AppConfig } from './app.abstract.config';
import { AppComponent } from './app.component';
import { appConfig } from './app.config';
import { TalentPoolFormGuard } from '@modules/talent-pools-page/guards/talent-pool-form.guard';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    LayoutModule,
    HammerModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately',
    }),
    PortalModule,
  ],
  providers: [
    TalentPoolFormGuard,
    {
      provide: AppConfig,
      useValue: appConfig,
    },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: CustomHammerConfig,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
